import { Star, Columns3 } from "lucide-react";
import { toast } from "sonner";
import { useIdList, SHORTLIST_KEY, COMPARE_KEY } from "@/lib/idList";

const stop = (fn) => (e) => { e.preventDefault(); e.stopPropagation(); fn(); };

export const NewBadge = ({ testId }) => (
  <span data-testid={testId} className="rounded-full bg-[#D96B43] text-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider">New</span>
);

export const StarButton = ({ id, testId, withLabel = false }) => {
  const { has, toggle } = useIdList(SHORTLIST_KEY);
  const on = has(id);
  return (
    <button onClick={stop(() => toggle(id))} aria-label={on ? "Remove from shortlist" : "Add to shortlist"} data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full transition-colors ${withLabel ? "border border-[#1C242B]/15 bg-white px-4 py-2 text-sm hover:bg-[#F6E7DF]" : "p-1.5 hover:bg-[#F6E7DF]"}`}>
      <Star size={16} className={on ? "fill-[#D96B43] text-[#D96B43]" : "text-slate-400"} />
      {withLabel && (on ? "On your shortlist" : "Add to shortlist")}
    </button>
  );
};

export const CompareButton = ({ id, testId, withLabel = false }) => {
  const { has, toggle } = useIdList(COMPARE_KEY, 3);
  const on = has(id);
  const click = () => { if (!toggle(id)) toast.error("You can compare up to 3 careers. Remove one first."); };
  return (
    <button onClick={stop(click)} aria-label={on ? "Remove from compare" : "Add to compare"} data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full transition-colors ${on ? "text-[#3E6B5C]" : "text-slate-400"} ${withLabel ? "border border-[#1C242B]/15 bg-white px-4 py-2 text-sm hover:bg-[#EEF4F0]" : "p-1.5 hover:bg-[#EEF4F0]"}`}>
      <Columns3 size={16} />
      {withLabel && (on ? "In compare" : "Add to compare")}
    </button>
  );
};
